module.exports = __webpack_public_path__ + "static/media/icon-font-italic.62116ed1.svg";